import { useLoadingStore } from "@/stores/Loading";

import CommonImg from "@/components/Common/Img";

import LoadingIcon from "@/assets/images/loading-icon.png";

export const GlobalLoading = () => {
  const isLoading =
    Object.keys(useLoadingStore((s) => s.loadingMap)).length > 0;

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black-100 bg-opacity-50 flex items-center justify-center">
      <div className="w-[467px] px-8 pt-12 pb-8 bg-white rounded-lg inline-flex flex-col items-center gap-7">
        <div className="w-10 h-10 relative overflow-hidden">
          <CommonImg
            className="w-10 h-10 left-[0.65px] top-[0.68px] animate-rotate-45-500ms"
            src={LoadingIcon}
            alt="Loading"
          />
        </div>
        <div className="self-stretch flex flex-col justify-start items-start gap-5">
          <div className="self-stretch text-center justify-start text-gray-A text-2xl font-bold">
            데이터 로딩 중...
          </div>
          <div className="self-stretch text-center justify-start text-gray-B text-lg font-normal">
            데이터 규모에 따라 시간이 소요될 수 있습니다.
          </div>
        </div>
      </div>
    </div>
  );
};
